import UserProfile from '@/views/app/user-profile/user-profile-layout.view'
import generalData from '@/views/app/user-profile/general-data.view'
import invoice from '@/views/app/user-profile/invoice.view'
import myPurchases from '@/views/app/user-profile/my_purchases.view'
import editProfile from '@/views/app/user-profile/edit-profile.view'
import detailsPurchases from '@/views/app/user-profile/details-purchases.view'
import addAddressInvoice from '@/views/app/user-profile/add-address-invoice.view'

export default [{
  path: 'my',
  alias: 'general',
  name: 'profile',
  component: UserProfile,
  children: [
    {
      path: '',
      name: 'general',
      alias: 'general',
      component: generalData,
      meta: {
        title: 'General',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    },
    {
      path: 'edit-profile',
      name: 'editProfile',
      component: editProfile,
      meta: {
        title: 'Editar',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    },
    {
      path: 'add_address',
      name: 'addInvoice',
      component: addAddressInvoice,
      meta: {
        title: 'Agregar dirección',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    },
    {
      path: 'invoice',
      name: 'invoice',
      component: invoice,
      meta: {
        title: 'Facturación',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    },
    {
      path: 'my_purchases',
      name: 'purchases',
      component: myPurchases,
      meta: {
        title: 'Mis compras',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    },
    {
      path: 'details_purchases',
      name: 'details',
      component: detailsPurchases,
      meta: {
        title: 'Detalle',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        hidden: 'none',
        height: 30
      }
    }
  ],
  meta: {
    title: 'Mi cuenta',
    colorHeader: '#E64858',
    top: 0,
    position: 'fixed',
    hidden: 'none',
    height: 30
  }
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/user-profile/user-profile.route.js